import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Создавайте собственные визитки с нуля. Загружайте изображение, выбирайте подходящую бумагу, а также способ нанесения и заказывайте высококлассные визитки, которые с первого взгляда представят вас в лучшем свете. Если у вас еще нет фирменного стиля, вы можете выбрать готовый дизайн-макет понравившейся визитной карточки из нашего магазина и дополнить его текстом.</p><p>Стандартная визитка 90х50мм.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
